<template>
  <img
    src="/artifact.png"
    alt="Artifact"
    width="40"
    height="40"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
